import { render } from "./ProsList.vue?vue&type=template&id=33d6acac&scoped=true"
import script from "./ProsList.vue?vue&type=script&lang=js"
export * from "./ProsList.vue?vue&type=script&lang=js"

import "./ProsList.vue?vue&type=style&index=0&id=33d6acac&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d6acac"]])

export default __exports__